import { withTrackProps } from "@dpdgroupuk/react-event-tracker";

import { COLLECTION_DETAILS_COMPONENT } from "../../../../constants/analytics";
import { QuantityCell } from "../../../../components/Table/Cells";

export default withTrackProps({
  onClickCollectedQuantity: COLLECTION_DETAILS_COMPONENT.CLICK_QUANTITY,
})(QuantityCell);
